export default {
  primary: {
    dark: "#01579B",
    normal: "#0288D1",
    light: "#B3E5FC"
  },
  secondary: {
    dark: "#008E11",
    normal: "#00B817",
    light: "#E3FCEF"
  },
  accent: {
    dark: "#BB0058",
    normal: "#EE2282",
    light: "#FFC9F0"
  },
  rede: {
    normal: "#FF7A00",
    light: "#FFF600"
  },
  profile: {
    normal: "#01579B",
    light: "#B3E5FC"
  },
  background: {
    dark: "#01579B",
    normal: "#0288D1"
  },
  text: {
    dark: "#01579B",
    normal: "#0288D1",
    light: "#B3E5FC"
  },
  permissionFields: {
    dark: "#008E11",
    normal: "#00B817",
    light: "#E3FCEF"
  },
  checkbox: {
    normal: "#0288D1"
  },
  link: {
    dark: "#01579B",
    normal: "#0288D1"
  },
  notification: {
    dark: "#BB0058",
    normal: "#00B817",
    light: "#00B817"
  },
  button: {
    primary: "#0288D1",
    secondary: "#00B817",
    accent: "#EE2282"
  },
  switch: {
    primary: "#01579B"
  }
};



// WEBPACK FOOTER //
// ./src/assets/colors/pdvend/index.js